import { createAction } from 'Lib/reduxUtils';

import { ACCEPT_CONSENT, CONSENT_REJECTED, CONSENT_SUBMITTED, INIT_CONSENTS } from './constants';
import { ConsentFields } from './types';

export const initConsents = createAction(INIT_CONSENTS);
export const acceptConsent = createAction(ACCEPT_CONSENT, (fields: ConsentFields) => ({ fields }));
export const consentSubmitted = createAction(CONSENT_SUBMITTED);
export const consentRejected = createAction(CONSENT_REJECTED);
